export const actionTypes = {
  REQUEST_START: 'PAYMENT.BANK_ALL.REQUEST_START',
  REQUEST_SUCCESS: 'PAYMENT.BANK_ALL.REQUEST_SUCCESS',
  REQUEST_FAILURE: 'PAYMENT.BANK_ALL.REQUEST_FAILURE',
};

export function startRequest() {
  return {
    type: actionTypes.REQUEST_START,
  };
}

export function requestSuccess(data) {
  return {
    type: actionTypes.REQUEST_SUCCESS,
    payload: data,
  };
}

export function requestFailure(error) {
  return {
    type: actionTypes.REQUEST_FAILURE,
    payload: error,
  };
}
